module.exports = "/static/images/BRPA-Member-Badge.png";